import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { CirclesConvexProvider } from './lib/convex';
import { watchTheme } from './lib/theme';
import './styles.css';

watchTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CirclesConvexProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </CirclesConvexProvider>
  </StrictMode>,
);
